import React from 'react';

function Icon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="234"
            height="333"
            version="1"
            viewBox="0 0 187.182 266.908"
            xmlSpace="preserve"
        >
            <rect
                width="186.951"
                height="266.302"
                x="0.115"
                y="0.303"
                fill="#fff"
                fillOpacity="1"
                stroke="gray"
                strokeDasharray="none"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                strokeWidth="0.606"
                rx="7.149"
                ry="7.17"
            ></rect>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M17.127 11.521c-3.236 0-5.841 2.566-5.841 5.755V249.72c0 3.188 2.605 5.754 5.84 5.754H170.24c3.237 0 5.84-2.566 5.84-5.754V17.276c0-3.189-2.603-5.755-5.84-5.755z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="2.849"
                d="M17.127 11.521c-4.021 0-5.841 2.566-5.841 5.755V249.72c0 3.188 2.605 5.754 5.84 5.754H170.24c3.237 0 5.84-2.566 5.84-5.754V17.276c0-3.189-2.603-5.755-5.84-5.755z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M18.78 17.167c-.815 0-1.47.646-1.47 1.449V248.38c0 .801.655 1.448 1.47 1.448h149.435c.815 0 1.472-.647 1.472-1.448V18.616c0-.803-.657-1.449-1.472-1.449z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M48.354 47.465a.704.704 0 00-.714.698v171.402c0 .389.318.7.714.7h89.39c.396 0 .713-.311.713-.7V48.163a.703.703 0 00-.714-.698h-89.39z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M62.407 53.543c-4.65 0-8.397 3.69-8.397 8.273v143.362c0 4.583 3.746 8.273 8.397 8.273h60.317c4.652 0 8.397-3.69 8.397-8.273V61.816c0-4.582-3.745-8.273-8.397-8.273z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M63.367 60.134c-1.58 0-2.851 1.241-2.851 2.783v141.16c0 1.542 1.272 2.783 2.85 2.783h58.615c1.58 0 2.854-1.24 2.854-2.783V62.917c0-1.542-1.273-2.783-2.854-2.783z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="1.641"
                d="M49.036 46.907a.704.704 0 00-.712.7V219.3c0 .39.317.7.712.7h89.11a.703.703 0 00.711-.7V47.607c0-.388-.315-.7-.711-.7h-89.11z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeOpacity="1"
                strokeWidth="2.063"
                d="M63.328 53.364c-4.667 0-8.425 3.697-8.425 8.287v143.605c0 4.591 3.758 8.288 8.425 8.288h60.525c4.668 0 8.426-3.697 8.426-8.288V61.651c0-4.59-3.758-8.287-8.426-8.287z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.797"
                d="M64.45 59.963c-1.569 0-2.833 1.243-2.833 2.788V204.15c0 1.545 1.264 2.788 2.834 2.788h58.276c1.572 0 2.838-1.243 2.838-2.788V62.75c0-1.544-1.266-2.787-2.838-2.787z"
            ></path>
            <path
                fill="red"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M18.906 18.826h6.708l-6.643 6.53-.065-6.53z"
            ></path>
            <path
                fill="red"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M167.987 18.91h-6.708l6.643 6.53.065-6.53z"
            ></path>
            <path
                fill="red"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M168.108 248.376h-6.709l6.645-6.529.064 6.529z"
            ></path>
            <path
                fill="red"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M18.9 248.342h6.709l-6.643-6.53z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="2.675"
                d="M18.873 17.124c-.816 0-1.47.646-1.47 1.448v229.764c0 .802.654 1.448 1.47 1.448h149.435c.815 0 1.472-.646 1.472-1.448V18.572c0-.802-.657-1.448-1.472-1.448z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeOpacity="1"
                strokeWidth="0.863"
                d="M18.999 18.784h6.708l-6.644 6.53-.064-6.53z"
            ></path>
            <path
                fill="red"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="0.863"
                d="M168.209 18.784h-6.717l6.652 6.53.065-6.53z"
            ></path>
            <path
                fill="red"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="0.863"
                d="M168.2 248.332h-6.708l6.645-6.528.063 6.528z"
            ></path>
            <path
                fill="red"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="10"
                strokeWidth="0.863"
                d="M18.994 248.298h6.708l-6.643-6.529z"
            ></path>
            <g
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.314"
                transform="matrix(1 0 0 1.00321 .312 -.965)"
            >
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.475 142.837v6.256l22.582-11.698v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.475 142.837v6.256l22.582-11.698v-6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.59 154.667v6.255l22.581-11.699v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.59 154.667v6.255l22.581-11.699v-6.408z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.64 130.845v6.256l22.581-11.7v-6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.64 130.845v6.256l22.581-11.7v-6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.532 137.358v-6.255l22.583 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.532 137.358v-6.255l22.583 11.698v6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.526 119.016v6.255l22.58-11.698v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.526 119.016v6.255l22.58-11.698v-6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.413 125.301v-6.255l22.581 11.7v6.406z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.413 125.301v-6.255l22.581 11.7v6.406z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.621 166.604v6.254l22.581-11.697v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.621 166.604v6.254l22.581-11.697v-6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.363 149.123v-6.255l22.58 11.698v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.363 149.123v-6.255l22.58 11.698v6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.392 83.231v6.255l22.581-11.698V71.38z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.392 83.231v6.255l22.581-11.698V71.38z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.506 95.06v6.256L44.09 89.617v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.506 95.06v6.256L44.09 89.617v-6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.558 71.237v6.257l22.58-11.7v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.558 71.237v6.257l22.58-11.7v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.449 77.752v-6.255L44.03 83.195v6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.449 77.752v-6.255L44.03 83.195v6.408z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.442 59.41v6.254l22.58-11.698v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.442 59.41v6.254l22.58-11.698v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.33 65.695V59.44l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.33 65.695V59.44l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.499 53.93v-6.255l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.499 53.93v-6.255l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.538 106.998v6.255l22.582-11.699v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.538 106.998v6.255l22.582-11.699v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.28 89.517v-6.255L43.86 94.959v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.28 89.517v-6.255L43.86 94.959v6.41z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.583 113.536v-6.255l22.581 11.7v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.583 113.536v-6.255l22.581 11.7v6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.31 101.454v-6.256l22.582 11.7v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.31 101.454v-6.256l22.582 11.7v6.407z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.475 202.28v6.257l22.582-11.7v-6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.475 202.28v6.257l22.582-11.7v-6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.59 214.11v6.254l22.581-11.698v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.59 214.11v6.254l22.581-11.698v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.363 208.567v-6.257l22.58 11.7v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.363 208.567v-6.257l22.58 11.7v6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.64 190.287v6.255l22.581-11.699v-6.407z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.526 178.46v6.254l22.58-11.7v-6.406z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.526 178.46v6.254l22.58-11.7v-6.406z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.393 161.06v-6.255l22.581 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.393 161.06v-6.255l22.581 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.64 190.287v6.255l22.581-11.699v-6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.532 196.8v-6.256l22.583 11.7v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.532 196.8v-6.256l22.583 11.7v6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.413 184.745v-6.256l22.581 11.699v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.413 184.745v-6.256l22.581 11.699v6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.583 172.979v-6.256l22.581 11.699v6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.583 172.979v-6.256l22.581 11.699v6.408z"
                ></path>
            </g>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeWidth="0.5"
                d="M177.398 249.83c0 3.85-3.107 7.007-6.918 7.007H16.587c-3.8 0-6.908-3.157-6.908-7.006V16.876c0-3.854 3.107-7.006 6.908-7.006H170.48c3.811 0 6.918 3.152 6.918 7.006z"
            ></path>
            <g
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.314"
                transform="matrix(1 0 0 1.00321 121.2 -.965)"
            >
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.475 142.837v6.256l22.582-11.698v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.475 142.837v6.256l22.582-11.698v-6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.59 154.667v6.255l22.581-11.699v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.59 154.667v6.255l22.581-11.699v-6.408z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.64 130.845v6.256l22.581-11.7v-6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.64 130.845v6.256l22.581-11.7v-6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.532 137.358v-6.255l22.583 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.532 137.358v-6.255l22.583 11.698v6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.526 119.016v6.255l22.58-11.698v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.526 119.016v6.255l22.58-11.698v-6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.413 125.301v-6.255l22.581 11.7v6.406z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.413 125.301v-6.255l22.581 11.7v6.406z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.621 166.604v6.254l22.581-11.697v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.621 166.604v6.254l22.581-11.697v-6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.363 149.123v-6.255l22.58 11.698v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.363 149.123v-6.255l22.58 11.698v6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.392 83.231v6.255l22.581-11.698V71.38z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.392 83.231v6.255l22.581-11.698V71.38z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.506 95.06v6.256L44.09 89.617v-6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.506 95.06v6.256L44.09 89.617v-6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.558 71.237v6.257l22.58-11.7v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.558 71.237v6.257l22.58-11.7v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.449 77.752v-6.255L44.03 83.195v6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.449 77.752v-6.255L44.03 83.195v6.408z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.442 59.41v6.254l22.58-11.698v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.442 59.41v6.254l22.58-11.698v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.33 65.695V59.44l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.33 65.695V59.44l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.499 53.93v-6.255l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.499 53.93v-6.255l22.582 11.697v6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.538 106.998v6.255l22.582-11.699v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.538 106.998v6.255l22.582-11.699v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.28 89.517v-6.255L43.86 94.959v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.28 89.517v-6.255L43.86 94.959v6.41z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.583 113.536v-6.255l22.581 11.7v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.583 113.536v-6.255l22.581 11.7v6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.31 101.454v-6.256l22.582 11.7v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.31 101.454v-6.256l22.582 11.7v6.407z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.475 202.28v6.257l22.582-11.7v-6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.475 202.28v6.257l22.582-11.7v-6.41z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.59 214.11v6.254l22.581-11.698v-6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.59 214.11v6.254l22.581-11.698v-6.408z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.363 208.567v-6.257l22.58 11.7v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.363 208.567v-6.257l22.58 11.7v6.409z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.64 190.287v6.255l22.581-11.699v-6.407z"
                ></path>
                <path
                    fill="#cc2020"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.526 178.46v6.254l22.58-11.7v-6.406z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.526 178.46v6.254l22.58-11.7v-6.406z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.393 161.06v-6.255l22.581 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.393 161.06v-6.255l22.581 11.698v6.41z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.64 190.287v6.255l22.581-11.699v-6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.532 196.8v-6.256l22.583 11.7v6.409z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.532 196.8v-6.256l22.583 11.7v6.409z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.413 184.745v-6.256l22.581 11.699v6.407z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.413 184.745v-6.256l22.581 11.699v6.407z"
                ></path>
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    stroke="none"
                    strokeMiterlimit="4"
                    d="M21.583 172.979v-6.256l22.581 11.699v6.408z"
                ></path>
                <path
                    fill="none"
                    fillRule="nonzero"
                    stroke="red"
                    strokeMiterlimit="10"
                    d="M21.583 172.979v-6.256l22.581 11.699v6.408z"
                ></path>
            </g>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M102.596 223.371H96.32l11.735 22.582h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M102.596 223.371H96.32l11.735 22.582h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M90.728 223.486h-6.275l11.737 22.582h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M90.728 223.486h-6.275l11.737 22.582h6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M114.626 223.537h-6.275l11.737 22.58h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M114.626 223.537h-6.275l11.737 22.58h6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M108.093 223.429h6.275l-11.736 22.582h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M108.093 223.429h6.275l-11.736 22.582h-6.43z"
            ></path>
            <path
                fill="#cc2027"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M126.494 223.422h-6.275l11.735 22.581h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M126.494 223.422h-6.275l11.735 22.581h6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M120.188 223.309h6.275l-11.737 22.582H108.3z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M120.188 223.309h6.275l-11.737 22.582H108.3z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M78.753 223.517h-6.275L84.213 246.1h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M78.753 223.517h-6.275L84.213 246.1h6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M96.29 223.26h6.275l-11.736 22.58H84.4z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M96.29 223.26h6.275l-11.736 22.58H84.4z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M150.527 223.403h-6.277l11.737 22.582h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M150.527 223.403h-6.277l11.737 22.582h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M138.55 223.435h-6.274l11.736 22.581h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M138.55 223.435h-6.274l11.736 22.581h6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M156.087 223.176h6.276l-11.735 22.582h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M156.087 223.176h6.276l-11.735 22.582h-6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M131.991 223.48h6.275l-11.736 22.58h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M131.991 223.48h6.275l-11.736 22.58h-6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M144.112 223.207h6.276l-11.737 22.581h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M144.112 223.207h6.276l-11.737 22.581h-6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M42.962 223.371h-6.276l11.737 22.582h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M42.962 223.371h-6.276l11.737 22.582h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M31.095 223.486H24.82l11.736 22.582h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M31.095 223.486H24.82l11.736 22.582h6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M36.655 223.26h6.277l-11.737 22.58h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M36.655 223.26h6.277l-11.737 22.58h-6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M54.994 223.537h-6.275l11.736 22.58h6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M66.86 223.422h-6.275l11.737 22.581h6.427z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M66.86 223.422h-6.275l11.737 22.581h6.427z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M84.315 223.29h6.275l-11.736 22.58h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M84.315 223.29h6.275l-11.736 22.58h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M54.994 223.537h-6.275l11.736 22.58h6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M48.46 223.429h6.276L42.998 246.01h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M48.46 223.429h6.276L42.998 246.01h-6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M60.554 223.309h6.275l-11.735 22.582h-6.429z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M60.554 223.309h6.275l-11.735 22.582h-6.429z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M72.357 223.48h6.276l-11.736 22.58h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M72.357 223.48h6.276l-11.736 22.58h-6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M102.596 20.986h-6.275l11.735 22.581h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M102.596 20.986h-6.275l11.735 22.581h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M90.729 21.1h-6.276L96.19 43.683h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M90.729 21.1h-6.276L96.19 43.683h6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M114.627 21.151h-6.276l11.738 22.581h6.427z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M114.627 21.151h-6.276l11.738 22.581h6.427z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M108.094 21.043h6.274l-11.736 22.582h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M108.094 21.043h6.274l-11.736 22.582h-6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M126.494 21.036h-6.275l11.735 22.582h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M126.494 21.036h-6.275l11.735 22.582h6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M120.188 20.923h6.275l-11.736 22.582h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M120.188 20.923h6.275l-11.736 22.582h-6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M78.753 21.132H72.48l11.734 22.58h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M78.753 21.132H72.48l11.734 22.58h6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M96.29 20.874h6.275L90.83 43.454H84.4z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M96.29 20.874h6.275L90.83 43.454H84.4z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M150.527 21.017h-6.277L155.987 43.6h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M150.527 21.017h-6.277L155.987 43.6h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M138.55 21.05h-6.274l11.736 22.58h6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M138.55 21.05h-6.274l11.736 22.58h6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M156.088 20.79h6.275l-11.735 22.582h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M156.088 20.79h6.275l-11.735 22.582h-6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M131.992 21.094h6.275L126.53 43.675h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M131.992 21.094h6.275L126.53 43.675h-6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M144.112 20.822h6.276l-11.737 22.58h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M144.112 20.822h6.276l-11.737 22.58h-6.428z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M42.963 20.986h-6.277l11.738 22.581h6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M42.963 20.986h-6.277l11.738 22.581h6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M31.095 21.1H24.82l11.736 22.582h6.429z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M31.095 21.1H24.82l11.736 22.582h6.429z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M36.655 20.874h6.278l-11.737 22.58h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M36.655 20.874h6.278l-11.737 22.58h-6.43z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M54.994 21.151H48.72l11.735 22.581h6.429z"
            ></path>
            <path
                fill="#cc2020"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M66.86 21.036h-6.275l11.738 22.582h6.426z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M66.86 21.036h-6.275l11.738 22.582h6.426z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M84.315 20.904h6.275L78.854 43.485h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M84.315 20.904h6.275L78.854 43.485h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M54.994 21.151H48.72l11.735 22.581h6.429z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M48.46 21.043h6.276L43 43.625h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M48.46 21.043h6.276L43 43.625h-6.43z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M60.554 20.923h6.276L55.094 43.505h-6.428z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M60.554 20.923h6.276L55.094 43.505h-6.428z"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeWidth="1.316"
                d="M72.358 21.094h6.275L66.898 43.675h-6.43z"
            ></path>
            <path
                fill="none"
                fillRule="nonzero"
                stroke="red"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.316"
                d="M72.358 21.094h6.275L66.898 43.675h-6.43z"
            ></path>
        </svg>
    );
}

export default Icon;
